import React, { Fragment, useState } from 'react';
import './GridGallery.scss'
import { grid_data } from '../../Constants';
import VideoModal from '../video_modal/VideoModal';
import { NavigateTo } from '../../Utilities';



export default function GridGallery() {
    const filteredGridData = grid_data.filter(item => item.showOnHomeGrid);
    const [videoId, setVideoId] = useState("");
    const [videoTitle, setVideoTitle] = useState("");
    const [modalIsOpen, setModalIsOpen] = useState(false);

    const openModal = () => {
        setModalIsOpen(true);
    };

    const closeModal = () => {
        setModalIsOpen(false);
    };
    return (
        <Fragment>
            <div className='grid-gallery-main-contianer'>
                <div className='grid-gallery'>
                    {filteredGridData.map((item, index) => (
                        <div className='hidden-text-container' key={index} onClick={() => {
                            setVideoId(item.videoId)
                            setVideoTitle(item.title)
                            openModal();
                        }}>
                            <div className='hidden-text'>
                                <div className='brand'>{item.brandName}</div>
                                <div className='desc'>{item.title}</div>
                                <div className='border-btm' />
                            </div>
                            <img className="content-img" src={`/${item.image}`} alt={item.image} />
                        </div>
                    ))}
                </div>
                <div className="see-category" onClick={(e: any) => NavigateTo(e, "categories")}>SEE ALL CATEGORIES</div>
            </div>
            <VideoModal isOpen={modalIsOpen} onClose={closeModal} videoId={videoId} videoTitle={videoTitle} />

        </Fragment>
    );
};